import { observer } from "mobx-react-lite"
import "./about.css"
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ReadyStart = observer(() => {
    const { t } = useTranslation();

    return (
        <div>
            <div style={{ height: "600px" }}>
                <div className="upper-bg">
                    <div className="logo"></div>
                    <h1><span className="black-text">{t("READY")}</span> <span>{t("TO")}</span> <span className="blue-text">{t("START")}</span></h1>
                    <div className="description">{t("Try SkTech free. No setup needed.")}</div>
                    <Link to="/register-company" target="_blank">
                        <img src="/assets/about/point_icon_left.svg" alt="point_icon_left" />
                        <button className="clean-mess">{t("SIGN UP FOR FREE")}</button>
                        <img src="/assets/about/point_icon_right.svg" alt="point_icon_right" />
                    </Link>
                    <div className="get-start-text">{t("Get started in 1 minute")}</div>
                </div>
            </div>
            <div></div>
            <div></div>
        </div>
    )
})
export default ReadyStart;